/* import __COLOCATED_TEMPLATE__ from './checking-upsell-modal.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
const BANK_LINKING_EXP_EVENT_NAME = 'BAT Bank linking checking upsell flow exp1';
const CLICK_LINK_BANK_ACCOUNT_EVENT = 'Click Link Bank Account';
const CLICK_SIGN_UP_CHECKING_EVENT = 'Click Sign Up for Square Checking';
const CLICK_EXIT_UPSELL_MODAL_EVENT = 'Click Exit Upsell Modal';
let CheckingUpsellModal = (_class = class CheckingUpsellModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dataApi", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
  }
  transitionToSquareChecking() {
    this.router.transitionTo('money.square_card.manage', {
      queryParams: {
        unitToken: this.args.unitToken
      }
    });
  }
  linkExternalBankAccount() {
    this.dataApi.track(BANK_LINKING_EXP_EVENT_NAME, {
      visitorUnitId: this.args.unitToken,
      visitorId: this.args.merchantToken,
      target: CLICK_LINK_BANK_ACCOUNT_EVENT
    });
    this.args.dismissModal(true);
  }
  addSquareChecking() {
    this.dataApi.track(BANK_LINKING_EXP_EVENT_NAME, {
      visitorUnitId: this.args.unitToken,
      visitorId: this.args.merchantToken,
      target: CLICK_SIGN_UP_CHECKING_EVENT
    });
    this.args.dismissModal(false);
    this.transitionToSquareChecking();
  }
  onDismiss() {
    this.dataApi.track(BANK_LINKING_EXP_EVENT_NAME, {
      visitorUnitId: this.args.unitToken,
      visitorId: this.args.merchantToken,
      target: CLICK_EXIT_UPSELL_MODAL_EVENT
    });
    this.args.dismissModal(false);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "linkExternalBankAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "linkExternalBankAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addSquareChecking", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addSquareChecking"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDismiss"), _class.prototype), _class);
export { CheckingUpsellModal as default };